import React, { PropsWithChildren } from "react";
import { SHARE_RECIPIENT_BASE_CLASS } from "./share-space-recipient-layout";
import UnauthorizedHeader from "molecules/header/unauthorized-header";
import TryLinkFooter from "molecules/footer/try-link-footer";

const AuthenticatedNonSubscriberLayout: React.FC<PropsWithChildren> = ({
    children,
}) => {
    return (
        <div
            className={SHARE_RECIPIENT_BASE_CLASS}
            data-test-id="authenticated-nonsub-layout">
            <header className={`${SHARE_RECIPIENT_BASE_CLASS}__header`}>
                <UnauthorizedHeader />
            </header>
            {children}
            <footer className={`${SHARE_RECIPIENT_BASE_CLASS}__footer`}>
                <TryLinkFooter />
            </footer>
        </div>
    );
};

export default AuthenticatedNonSubscriberLayout;
